/* PLGRIM — motion.js
   Site chrome and scroll transitions: the light/dark toggle, parallax drift on
   full-bleed media, and line-by-line rise on statement headings.
   Loaded after theme.js. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- light / dark ---------- */
  var root = document.documentElement;
  var STORE_KEY = 'plgrim-theme';

  function currentTheme() {
    return root.getAttribute('data-theme') ||
      ((window.PLGRIM && window.PLGRIM.defaultTheme) || 'dark');
  }

  function applyTheme(next) {
    root.setAttribute('data-theme', next);
    try { localStorage.setItem(STORE_KEY, next); } catch (e) {}
    $$('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-label', next === 'dark' ? 'Switch to light' : 'Switch to dark');
    });
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute('content', getComputedStyle(root).getPropertyValue('--canvas').trim());
    }
  }

  // reflect the starting state on the button without writing to storage
  $$('[data-theme-toggle]').forEach(function (btn) {
    btn.setAttribute('aria-label', currentTheme() === 'dark' ? 'Switch to light' : 'Switch to dark');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    e.preventDefault();
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  });

  /* ---------- line splitting ---------- */
  function splitLines(el) {
    var source = el.getAttribute('data-lines-text');
    if (!source) {
      source = el.textContent.replace(/\s+/g, ' ').trim();
      el.setAttribute('data-lines-text', source);
    }

    var words = source.split(' ');
    el.textContent = '';
    var probe = document.createDocumentFragment();
    var spans = words.map(function (w, i) {
      var s = document.createElement('span');
      s.textContent = i < words.length - 1 ? w + ' ' : w;
      probe.appendChild(s);
      return s;
    });
    el.appendChild(probe);

    var lines = [], current = [], last = null;
    spans.forEach(function (s) {
      var top = s.offsetTop;
      if (last === null || Math.abs(top - last) < 4) { current.push(s); }
      else { lines.push(current); current = [s]; }
      last = top;
    });
    if (current.length) lines.push(current);

    el.textContent = '';
    lines.forEach(function (line) {
      var outer = document.createElement('span');
      outer.className = 'line';
      var inner = document.createElement('span');
      line.forEach(function (s) { inner.appendChild(s); });
      outer.appendChild(inner);
      el.appendChild(outer);
    });
  }

  function initLines() {
    if (reduce) return;
    $$('[data-lines]').forEach(splitLines);
  }
  initLines();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initLines, 220);
  });

  /* ---------- parallax drift ---------- */
  var media = [];
  function collect() {
    media = $$('[data-parallax]').map(function (img) {
      return { img: img, wrap: img.closest('[data-parallax-wrap]') || img.parentElement };
    });
  }
  collect();

  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < media.length; i++) {
      var m = media[i];
      var r = m.wrap.getBoundingClientRect();
      if (r.bottom < -240 || r.top > vh + 240) continue;
      // -1 once fully above the fold, +1 while still below it
      var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
      if (p > 1) p = 1; else if (p < -1) p = -1;
      m.img.style.transform = 'translate3d(0,' + (p * 5).toFixed(2) + '%,0)';
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  if (!reduce) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { collect(); onScroll(); });
    frame();
  }

  document.addEventListener('shopify:section:load', function () {
    collect();
    initLines();
    if (!reduce) frame();
  });
})();
